import { Gutter } from 'antd/lib/grid/row';

export const STAGE_3 = {
  SCOPE_1_AND_2_LABELS: {
    GUTTER_VALUE: [15, 25] as Gutter,
    FARM_NAME: 'Farm name',
    FARM_ADDRESS: 'Farm’s address',
    FARM_SCOPE1: 'Farm’s scope 1 (tonnes CO2e)',
    FARM_SCOPE2: 'Farm’s scope 2 (tonnes CO2e)',
    FARM_ALLOCATION: 'Allocation %',
    TOTAL_EMISSION: 'Total emissions per field (tonnes CO2e)',
    LIVE_STOCK_SCOPE2: 'Farm’s scope 2 (tonnes CO2e)',
    LIVE_STOCK_ALLOCATION: '% of farm revenue',
    LIVE_STOCK_TOTAL_EMISSION: 'Total emissions from fuel and energy (tonnes CO2e)',
  },

  FUEL_AND_ENERGY_FIELD_NAMES: {
    FIELD_FARM_NAME: 'farmName',
    FIELD_FARM_ADDRESS: 'address.getFormattedAddress',
    FIELD_FARM_SCOPE1: 'scope1Emission',
    FIELD_FARM_SCOPE2: 'scope2Emission',
    FIELD_REVENUE_PERCENTAGE: 'revenuePercentage',
    FIELD_TOTAL_EMISSION: 'scope1And2Emission',
  },
  HEADINGS: {
    LOCATION: 'location',
    COMMODITY: 'commodity',
  }
};
